<template>
<div>
	<div>
		<div class="col-lg-12">
			<h2 class="page-header">
				<span id="page-header">{{ pageheader }}</span>
				<a href="/graves/" class="hidden-md hidden-lg"><button class="btn btn-success">Zur Liste</button></a>
			</h2>

			<div class="row">
				<h3 class="col-lg-12">Allgemeine Informationen  <router-link class="btn btn-primary create-new pull-right" to="/graves/new"><i class="fa fa-plus"></i></router-link></h3>
				<div class="form-horizontal" id="customer-information">

					<div class="row">
						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="type">Art <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<select id="type" v-model="type_id" class="form-control">
										<option value="0">[Nicht spezifiziert]</option>
										<option v-for="gtype in $store.getters.models('grave_types')" :value="gtype.id">{{ gtype.name }}</option>
									</select>
								</div>
							</custom-input>
						</div>

						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="grave_name">Name <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<input name="grave_name" id="grave_name" class="form-control" v-model="model.model.name" required>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="grave_area">Fläche ({{model.model.category_name}})  <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<div class="input-group">
										<input style="cursor: pointer" @click="selectArea()" id="grave_area" name="grave_area" class="form-control" type="text" v-model="model.model.area_name" readonly>
										<span class="input-group-addon addon-primary" @click="selectArea()"><i class="fa fa-pencil"></i></span>
										<router-link class="input-group-addon addon-success" :to="'/areas/' + model.model.area_id" v-if="model.model.area_id > 0"><i class="fa fa-arrow-right"></i></router-link>
									</div>
								</div>
							</custom-input>
						</div>

						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="grave_price">Preis (Fläche: {{ area_price }} &euro;)</label>
								<div class="col-sm-12">
									<input id="grave_price" name="grave_price" class="form-control" required="required" v-model="model.model.price" type="number" min="0">
								</div>
							</custom-input>
						</div>
					</div>

					<custom-input inline>
						<label class="col-sm-12 control-label" for="grave_description">Beschreibung</label>
						<div class="col-sm-12">
							<input name="grave_description" id="grave_description" class="form-control" required="required" v-model="model.model.description">
						</div>
					</custom-input>

					<div class="row">
						<div class="form-group">
							<div class="col-lg-12 text-center">
								<a href="/graves/" class="hidden-sm hidden-xs"><button class="btn btn-success">Zur Liste</button></a>
								<button v-if="validGrave" class="btn btn-primary" @click="saveGrave()">Speichern</button>
							</div>
						</div>
					</div>

					<div class="row" v-show="model.model.id > 0">
						<div class="col-lg-12">
							<div class="col-lg-12">
								<ul class="nav nav-tabs responsive-tabs">
									<li class="active"><a href="#customers">Nutzungsberechtigte</a></li>
									<li><a href="#deceaseds">Verstorbene</a></li>
								</ul>

								<div class="tab-content col-lg-12">
									<div class="tab-pane active" id="customers">
										<custom-table :cols="customerCols" :src-model="model.customers" add delete edit nosort select="/customers/{:customer_id}" @add="addRelation('customers')" @edit="editCustomer" @delete="deleteCustomer" :default-sort="defSort"></custom-table>
									</div>

									<div class="tab-pane" id="deceaseds">
										<custom-table :cols="deceasedsCols" :src-model="model.deceaseds" add edit delete nosort select="/deceaseds/{:deceased_id}" @add="addRelation('deceaseds')" @edit="editDeceased" @delete="deleteDeceased" :default-sort="defSort"></custom-table>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- Fläche -->
		<custom-modal v-if="visibleModal === 'selectArea'" :title="selectAreaMode === 'new' ? 'Fläche anlegen' : 'Fläche auswählen'" @cancel="visibleModal = ''" @ok="newArea()" ok-style="btn btn-primary" :ok-text="selectAreaMode === 'new' ? 'Speichern' : null">
			<div class="row">
				<div class="col-lg-12">
					<button class="btn btn-default btn-sm" @click="selectAreaMode = 'relation'">Auswählen</button>
					<button class="btn btn-default btn-sm" @click="selectAreaMode = 'new'">Hinzufügen</button>
				</div>
			</div>

			<div class="row">
				<div class="col-lg-12">
					<custom-table v-if="selectAreaMode === 'relation'" row-add @rowAdd="pickArea" :src-model="$store.getters.models('areas')" :cols="areaCols" store="areas" search :default-sort="defSort"></custom-table>

					<div v-if="selectAreaMode === 'new'">
						<custom-input inline>
							<label class="col-sm-12 control-label" for="name">Name</label>
							<div class="col-sm-12">
								<input name="name" class="form-control" v-model="areas.model.name" required>
							</div>
						</custom-input>

						<custom-input inline>
							<label class="col-sm-12 control-label" for="description">Beschreibung</label>
							<div class="col-sm-12">
								<input name="description" class="form-control" v-model="areas.model.description" required>
							</div>
						</custom-input>

						<custom-input inline>
							<label class="col-sm-12 control-label" for="price">Preis</label>
							<div class="col-sm-12">
								<input name="price" class="form-control" v-model="areas.model.price" required>
							</div>
						</custom-input>

						<custom-input inline>
							<label class="col-sm-12 control-label" for="coordinates">Koordinaten</label>
							<div class="col-sm-12">
								<input name="coordinates" class="form-control" v-model="areas.model.coordinates" required>
							</div>
						</custom-input>
					</div>
				</div>
			</div>
		</custom-modal>

		<!-- Grab Arten -->
		<custom-modal v-if="visibleModal === 'selectGraveType'" title="Art des Grabes auswählen" @cancel="visibleModal = ''">
			<div class="row">
				<div class="col-lg-12">
					<custom-table row-add @rowAdd="pickGraveType" :src-model="$store.getters.models('grave_types')" :cols="graveTypeCols" store="grave_types" search :default-sort="defSort"></custom-table>
				</div>
			</div>
		</custom-modal>

		<!-- Verstorbene -->
		<custom-modal v-if="visibleModal === 'adddeceaseds'" title="Verstorbenen zuweisen" cancel-text="Abbrechen" cancel-style="btn btn-default" @cancel="visibleModal = ''">
			<div class="row">
				<div class="col-lg-10">
					<custom-input title="Verstorbener">
						<custom-table row-add @rowAdd="saveDeceased" :src-model="$store.getters.models('deceaseds')" :cols="deceasedSearchCols" store="deceaseds" search :default-sort="defSort"></custom-table>
						<!-- <custom-table row-add @rowAdd="saveDeceased" :src-model="$store.getters.models('deceaseds')" :cols="deceasedCols"       store="deceaseds" search :default-sort="graveSort"></custom-table> -->
					</custom-input>
				</div>

				<div class="col-lg-2">
					<custom-input title="Von">
						<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="from" v-model="deceaseds.model.from" required language="de" format="yyyy-MM-dd"></datepicker>
					</custom-input>

					<custom-input title="Bis">
						<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="until" v-model="deceaseds.model.until" required language="de" format="yyyy-MM-dd"></datepicker>
					</custom-input>
				</div>
			</div>
		</custom-modal>

		<custom-modal v-if="visibleModal === 'editdeceaseds'" title="Verstorbenen bearbeiten" @cancel="visibleModal = ''" @ok="updateDeceased" ok-text="Aktualisieren" cancel-text="Abbrechen" cancel-style="btn btn-default">
			<custom-input title="Von">
				<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="from" v-model="deceaseds.model.from" required language="de" format="yyyy-MM-dd"></datepicker>
			</custom-input>

			<custom-input title="Bis">
				<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="until" v-model="deceaseds.model.until" required language="de" format="yyyy-MM-dd"></datepicker>
			</custom-input>
		</custom-modal>

		<custom-modal title="Verstorbenen entfernen" v-if="visibleModal === 'deletedeceaseds'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('deceaseds')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie das Grab entfernen möchten?</strong>
		</custom-modal>

		<!-- Ansprechpartner -->
		<custom-modal v-if="visibleModal === 'addcustomers'" title="Nutzungsberechtigten hinzufügen" cancel-text="Abbrechen" cancel-style="btn btn-default" @cancel="visibleModal = ''">
			<div class="row">
				<div class="col-lg-10">
					<custom-input title="Kunde">
						<custom-table row-add @rowAdd="saveCustomer" :src-model="$store.getters.models('customers')" :cols="customerSearchCols" store="customers" search :default-sort="defSort"></custom-table>
					</custom-input>
				</div>

				<div class="col-lg-2">
					<custom-input title="Von">
						<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="from" v-model="customers.model.from" required language="de" format="yyyy-MM-dd"></datepicker>
					</custom-input>

					<custom-input title="Bis">
						<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="until" v-model="customers.model.until" required language="de" format="yyyy-MM-dd"></datepicker>
					</custom-input>
				</div>
			</div>
		</custom-modal>

		<custom-modal v-if="visibleModal === 'editcustomers'" title="Nutzungsberechtigten bearbeiten" @cancel="visibleModal = ''" @ok="updateCustomer" ok-text="Aktualisieren" cancel-text="Abbrechen" cancel-style="btn btn-default">
			<custom-input title="Von">
				<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="from" v-model="customers.model.from" required language="de" format="yyyy-MM-dd"></datepicker>
			</custom-input>

			<custom-input title="Bis">
				<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="until" v-model="customers.model.until" required language="de" format="yyyy-MM-dd"></datepicker>
			</custom-input>
		</custom-modal>

		<custom-modal title="Nutzungsberechtigten entfernen" v-if="visibleModal === 'deletecustomers'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('customers')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie diesen Nutzungsberechtigten entfernen möchten?</strong>
		</custom-modal>

		<!-- Fehlermeldungen -->
		<custom-modal v-if="visibleModal === 'errSavingModel'" @ok="visibleModal = ''" ok-text="OK" @cancel="visibleModal = ''">
			Fehler beim Speichern des Kunden.
		</custom-modal>
	</div>
</div>

</template>

<script>
import CustomTable from 'components/custom-table.vue'
import CustomModal from 'components/custom-modal-old.vue'
import CustomInput from 'components/custom-input.vue'

import Datepicker from 'vuejs-datepicker'

import CustomersModel from 'models/customers.js'
import GravesModel from 'models/graves.js'
import DeceasedsModel from 'models/deceaseds.js'
import AreasModel from 'models/areas.js'

import modelTools from 'functions/models.js'
import relationTools from 'functions/relations.js'
import deceasedTools from 'functions/deceased.js'
import customerTools from 'functions/customer.js'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('graves')
		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	beforeRouteLeave(to, from, next) {
		if (to.path === '/'+this.model.name+'/new') {
			this.model.clearModel()
		}
		next()
	},

	// Normale Eigenschaften
	data () {
		return {
			model: GravesModel,
			deceaseds: DeceasedsModel,
			customers: CustomersModel,
			areas: AreasModel,

			// visibleModal: 'addgraves'
			visibleModal: '',
			selectAreaMode: 'relation',

			customerCols: [
				{
					name: 'Name',
					json: 'name',
					type: 'text'
				},
				{
					name: 'Von',
					json: 'from',
					type: 'date'
				},
				{
					name: 'Bis',
					json: 'until',
					type: 'date'
				}
			],

			deceasedsCols: [
				{ name: 'Name', json: 'name', type: 'text' },
				{ name: 'Von', json: 'from', type: 'date' },
				{ name: 'Bis', json: 'until', type: 'date' }
			],

			deceasedSearchCols: [
				{ name: 'Name', json: 'firstname', type: 'text' },
				{ name: 'Name', json: 'lastname', type: 'text' },
				{ name: 'Geburtstag', json: 'birthday', type: 'date' },
				{ name: 'Todestag', json: 'dyingday', type: 'date' }
			],

			customerSearchCols: [
				{ name: 'Vorname', json: 'firstname', type: 'text' },
				{ name: 'Nachname', json: 'lastname', type: 'text' }
			],

			areaCols: [
				{ name: 'Name', json: 'name', type: 'text' },
				{ name: 'Preis', json: 'real_price', type (aValue) { return [ aValue + ' €' ] } }
			],

			graveTypeCols: [
				{ name: 'Name', json: 'name', type: 'text' },
				{ name: 'Kürzel', json: 'short_name', text: 'text' }
			],

			defSort: {col: 'id', order: 'asc'}
		}
	},

	activated () {
		this.model.clearModel()
		this.model.model.id = parseInt(this.$route.params.id)
		if (isNaN(this.model.model.id)) {
			this.model.model.id = 0
		}

        this.$store.dispatch('loadModels', this.model.relations)

		this.$store.dispatch('loadModel', 'graves')
		.then(result => {
			var model = this.$store.getters.model('graves', this.model.model.id)
			this.model.copy(model)
			this.model.model.name = model.name

			this.$store.dispatch('loadRelation', {basis: this.model, relation: 'customers'})
			.then(data => this.initRelation('customers', data))

			this.$store.dispatch('loadRelation', {basis: this.model, relation: 'deceaseds'})
			.then(data => this.initRelation('deceaseds', data))

			$('.responsive-tabs').responsiveTabs({
				accordionOn: ['xs', 'sm'] // xs, sm, md, lg
			})
		})
	},

	computed: {
		type_id: {
			get () {
				return this.model.model.type_id
			},

			set (newValue) {
                this.model.model.type_id = newValue
				if (this.model.model.name === '') {
					let CountType = this.$store.getters.models('graves').filter(Value => Value.type_id === newValue).length + 1
					this.model.model.name = this.$store.getters.model('grave_types', newValue).name + ' ' + CountType
				}
			}
		},

		validGrave () {
			const TypeOK = typeof this.model.model.type_id === "number" && this.model.model.type_id > 0 && Math.floor(this.model.model.type_id) === this.model.model.type_id
			const NameOK = typeof this.model.model.name === "string" && this.model.model.name.trim() !== ""
			const AreaOK = typeof this.model.model.area_id === "number" && this.model.model.area_id > 0 && Math.floor(this.model.model.area_id) === this.model.model.area_id

			return TypeOK && NameOK && AreaOK
		},

		pageheader () {
			let model
			let name

			if (this.model.model.id === 0) {
				return 'Neues Grab anlegen'
			} else {
				model = this.$store.getters.model('graves', this.model.model.id)
				name = model.name

				return 'Grab "' + name.trim() + '" verwalten'
			}
		},

		area_price () {
			return parseFloat(this.model.model.area_price) < 1 ? parseFloat(this.model.model.category_price) : parseFloat(this.model.model.area_price)
		}
	},

	components: {
		CustomTable,
		CustomModal,
		CustomInput,
		Datepicker
	},

	methods: {
		// Tools des Models
		saveModel: modelTools.save,

		// Beziehungen zwischen Models
		initRelation: relationTools.init,
		editRelation: relationTools.edit,
		deleteRelation: relationTools.delete,
		addRelation: relationTools.add,
		saveRelation: relationTools.save,
		confirmDeleteRelation: relationTools.confirmDelete,

		// Grab speziefische Methoden
		editDeceased: deceasedTools.edit,
		deleteDeceased: deceasedTools.delete,

		// Nutzungsberechtigten speziefische Methoden
		editCustomer: customerTools.edit,
		deleteCustomer: customerTools.delete,

		saveCustomer (aModel) {
//			let relation = { grave_id: this.model.model.id, customer_id: aModel.id, from: aModel.from, until: aModel.until }
			//this.deceaseds.copy(aModel)

			this.customers.model.id = 0
			this.customers.model.customer_id = aModel.id
			this.customers.model.grave_id = this.model.model.id

			this.saveRelation('customers')
			this.visibleModal = ''
		},

		updateCustomer () {
			this.saveRelation('customers')
			this.visibleModal = ''
		},

		updateDeceased () {
			this.deceaseds.model.name = this.deceaseds.model.deceased_id + ': Dummy'
			this.saveRelation('deceaseds')
			this.visibleModal = ''
		},

		saveDeceased (aModel) {
			// this.deceaseds.copy(aModel)
			this.deceaseds.model.name = aModel.id + ': Dummy'
			this.deceaseds.model.id = 0
			this.saveRelation('deceaseds')
			this.visibleModal = ''
		},

		saveGrave () {
			this.saveModel()
			.then(id => {
				this.model.model.id = id
				this.$router.replace("/graves/" + id)
			})
			.catch(id => {
				this.model.model.id = id
			})
		},

		selectArea () {
			this.visibleModal = 'selectArea'
		},

		clearArea () {
			this.model.model.area_id = 0
			this.model.model.area_name = '[Keine Fläche]'
		},

		pickArea (aModel) {
			this.model.model.area_id = aModel.id
			this.model.model.area_name = aModel.name
			this.visibleModal = ''
		},

		newArea () {
			this.saveModel(this.areas, true)
			.then(response => {
				this.pickArea(response)
			})
			.catch(err => {
				//
			})
		},

		print (aModels) {
			aModels[0] = aModels[0].map(aValue => {
				return {text: aValue, style: 'tableHeader', alignment: 'center'}
			})

			let dd = {
				footer: function (currentPage, pageCount) {
					return { text: 'Seite ' + currentPage + ' von ' + pageCount, alignment: (currentPage % 2) ? 'left' : 'right' };
				},

				content: [
					{
						table: {
							headerRows: 1,
							widths: ['*', '*', '*', '*'],

							body: aModels
						}
					}
				],
				styles: {
					header: {
						fontSize: 18,
						bold: true,
						margin: [0, 0, 0, 10]
					},
					subheader: {
						fontSize: 16,
						bold: true,
						margin: [0, 10, 0, 5]
					},
					tableExample: {
						margin: [0, 5, 0, 15]
					},
					tableHeader: {
						bold: true,
						fontSize: 13,
						color: 'black'
					}
				}
			}

			pdfMake.createPdf(dd).open()
		}
	}
}
</script>

<style>
.addon-primary {
	background-color: #337ab7;
	color: white;
}

.addon-primary:hover {
	background-color: #286090;
	color: white;
	cursor: pointer;
}

.addon-success {
	background-color: #5cb85c;
	color: white;
}

.addon-success:hover {
	background-color: #3F903F;
	color: white;
	cursor: pointer;
}

.addon-danger {
	background-color: #d9534f;
	color: white;
}

.addon-danger:hover {
	background-color: #C9302C;
	color: white;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// GraveEdit.vue?c8357764